// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin_main__noG4- {
    width: 100%;
    height: 100%;
}

.admin_content__ijHJx {
    padding: 30px;
    overflow-x: hidden;
    overflow-y: scroll;
}

/* 自定义滚动条 */
.admin_content__ijHJx::-webkit-scrollbar {/*滚动条整体样式*/
    -webkit-appearance: none;
    width: 10px;
    height: 10px;
}

.admin_content__ijHJx::-webkit-scrollbar-thumb {/*滚动条里面小方块*/
    cursor: pointer;
    border-radius: 5px;
    background: #e9e9e9;
    -webkit-transition: color .2s ease;
    transition: color .2s ease;
}

.admin_content__ijHJx::-webkit-scrollbar-thumb:hover {
    background: #e3e3e3;
}`, "",{"version":3,"sources":["webpack://./src/pages/admin/index.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA,WAAW;AACX,0CAA6B,UAAU;IACnC,wBAAwB;IACxB,WAAW;IACX,YAAY;AAChB;;AAEA,gDAAmC,WAAW;IAC1C,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IAEnB,kCAA0B;IAA1B,0BAA0B;AAC9B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".main {\n    width: 100%;\n    height: 100%;\n}\n\n.content {\n    padding: 30px;\n    overflow-x: hidden;\n    overflow-y: scroll;\n}\n\n/* 自定义滚动条 */\n.content::-webkit-scrollbar {/*滚动条整体样式*/\n    -webkit-appearance: none;\n    width: 10px;\n    height: 10px;\n}\n\n.content::-webkit-scrollbar-thumb {/*滚动条里面小方块*/\n    cursor: pointer;\n    border-radius: 5px;\n    background: #e9e9e9;\n    -webkit-transition: color .2s ease;\n    transition: color .2s ease;\n}\n\n.content::-webkit-scrollbar-thumb:hover {\n    background: #e3e3e3;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `admin_main__noG4-`,
	"content": `admin_content__ijHJx`
};
export default ___CSS_LOADER_EXPORT___;
